import DistanceCell from './component';
import { compose, withProps, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { openJourneyMapModal } from 'redux/modules/journey-map/effects';
import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const t = {
  unit: {
    ES: 'km',
    UK: 'mi',
    FR: 'km',
    NL: 'km',
    EU: 'km',
  },
};

const countryField = {
  ES: 'distance',
  UK: 'distanceMiles',
  FR: 'distance',
  NL: 'distance',
  EU: 'distance',
};

const fields = [
  'distance',
  'distance_miles',
  'route',
  'start_time_from',
  'status',
  'driver',
  'stops',
  'url',
];

const actionCreators = {
  openJourneyMapModal,
};

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const {
      distance_miles: distanceMiles,
      distance,
      route,
      start_time_from,
      status,
      driver,
      stops,
      url,
    } = props.selectors.getJourneyFields(state, props.journeyId, fields);

    const country = (route && route.country) || 'ES';

    return {
      distance,
      distanceMiles,
      country,
      start_time_from,
      status,
      driver,
      stops,
      url,
    };
  }, actionCreators),
  withProps(({ country, ...props }) => ({
    distance: parseInt(props[countryField[country]], 10),
    distanceUnit: t.unit[country],
  })),
  withHandlers({
    handleClick:
      ({ start_time_from, status, driver, stops, journeyId, url, openJourneyMapModal }) =>
      (e, openInGoogleMaps) => {
        e.stopPropagation();

        openJourneyMapModal({
          item: { id: journeyId, url, start_time_from, status, driver, stops },
          forceGoogleMaps: openInGoogleMaps,
        });
      },
  })
);

export default enhance(DistanceCell);
